import { notification } from "antd";
import {
  CheckmarkIcon,
  CloseIcon,
  WarningIcon,
  ClockIcon,
} from "@/assets/images";

export const Notify = (message: string, isSuccess: boolean) => {
  const isMobile = window.innerWidth <= 768;
  notification.config({
    maxCount: 3,
  });
  return notification.open({
    message: (
      <span style={{ color: "black", fontWeight: "600" }}>
        {isSuccess ? "Success" : "Error"}
      </span>
    ),
    duration: 5,
    description: <span style={{ color: "black" }}>{message}</span>,
    style: {
      background: "white",
      color: "black",
      borderRadius: 10,
      ...(isMobile
        ? {
            position: "fixed",
            top: "20px",
            left: "50%",
            transform: "translateX(-50%)",
            width: "calc(100vw - 32px)",
            maxWidth: "350px",
            border: "1px solid #006F0150",
            marginLeft: "0",
            marginRight: "0",
            zIndex: 9999,
          }
        : {
            maxWidth: "400px",
          }),
    },
    placement: isMobile ? "top" : "topRight",
    closeIcon: <CloseIcon width={10} height={10} color={"#656565"} />,
    icon: !isSuccess ? (
      <div
        style={{
          padding: "4px",
          backgroundColor: "rgba(255,0,0,10%)",
          borderRadius: "100%",
        }}
      >
        <WarningIcon width={20} height={20} color={"#FF0000"} />
      </div>
    ) : (
      <div
        style={{
          padding: "4px",
          backgroundColor: "rgba(0,111,1,10%)",
          borderRadius: "100%",
        }}
      >
        <CheckmarkIcon width={16} height={16} />
      </div>
    ),
  });
};

export const ComingSoonNotify = (message: string) => {
  return notification.open({
    message: (
      <span style={{ color: "black", fontWeight: "600" }}>Coming Soon</span>
    ),
    duration: 5,
    description: <span style={{ color: "black" }}>{message}</span>,
    style: {
      background: "white",
      color: "black",
      borderRadius: 10,
    },
    closeIcon: <CloseIcon width={10} height={10} color={"#656565"} />,
    icon: (
      <div
        style={{
          padding: "4px",
          backgroundColor: "rgba(255, 165, 0, 10%)",
          borderRadius: "100%",
        }}
      >
        <ClockIcon width={20} height={20} color={"#FFA500"} />
      </div>
    ),
  });
};
